import { Component } from "@angular/core";

@Component({
  selector: "success-v-icon",
  templateUrl: "./success-v-icon.component.html",
  styleUrls: ["./success-v-icon.component.scss"],
})
export class SuccessVIconComponent {
  constructor() {}
}
